<script>
import Changes from "@wielink-application/shared/js/mixins/changes";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import {useForm} from "@inertiajs/vue3";
import File from "@/pages/components/form/horizontal/file.vue";
import InputFile from "@/pages/components/form/horizontal/file.vue";
import InputOnly from "@/pages/components/form/input-only/input.vue";

export default {
	mixins: [Changes, FormElements],
	components: {InputFile, File, InputOnly},
	data() {
		return {
			form: useForm({
				'title': '',
				'base64': '',
				'assetable_group': '',
				'assetable_id': '',
				'assetable_type': '',
				'asset_id': null
			})
		}
	},
	methods: {
		async setTitle(value) {
			let previousTitle = this.form.title;
			this.form.title = value.name.replace(/\..*$/, '')
			if (previousTitle != '') {
				if (await Helpers.Alert.confirm(`We hebben de titel aangepast op basis van het nieuwe bestand.<br />Wilt u de originele titel "${previousTitle}" behouden`) ) {
					this.form.title = previousTitle;
				}
			}
		},
		setAsset(asset, data) {
			this.form.defaults({
				assetable_group : data.assetableGroup,
				assetable_id : data.assetableId,
				assetable_type : data.assetableType,
				base64 : {},
				title : asset.title,
				asset_id : asset.id
			});
			this.form.reset();
		},
		newAsset(data) {
			this.form.defaults({
				assetable_group : data.assetableGroup,
				assetable_id : data.assetableId,
				assetable_type : data.assetableType,
				base64 : {},
				title : '',
				asset_id : null
			});
			this.form.reset();
		},
	}
}
</script>

<template>
	<Input
		v-model="form.title"
		:form="form"
		name="title"
		label="Titel van bestand"
		required
	/>

	<InputOnly
		v-model="form.assetable_group"
		:form="form"
		name="assetable_group"
		type="hidden"
	/>

	<InputFile
		v-model="form.base64"
		:form="form"
		name="base64"
		label="Bestand"
		:asset_id="form.asset_id"
		required
		@update:modelValue="setTitle"
	/>

</template>
